import TabLinkIncidentPanel from "./TabLinkIncidentPanel";

export default TabLinkIncidentPanel;
